<template>
    <aside class="menu-expanded">
        <el-menu :default-active="$route.path"
                 @open="handleOpen"
                 @close="handleClose" @select="handleSelect"
                 unique-opened
                 router>
            <el-menu-item index="" @click="refreshFrontend"
                          class="refresh-frontend">
                <i class="fa fa-save white"></i> Wprowadź zmiany
            </el-menu-item>
            <template v-for="(item,index) in availableRoutes">
                <el-submenu :index="index+''" v-if="!item.leaf">
                    <!-- Menu Item Header -->
                    <template slot="title">
                        <i :class="item.iconCls"></i> <span class="menu__item">{{ getRouteName(item) }}</span>
                    </template>
                    <!-- Menu Item Children -->
                    <el-menu-item v-for="child in item.children"
                                  :index="getChildPath(item.path, child.path)"
                                  :key="getChildPath(item.path, child.path)"
                                  v-if="!child.hidden"
                                  class="menu__item">
                        {{ getRouteName(child) }}
                    </el-menu-item>
                </el-submenu>
                <el-menu-item v-if="item.leaf && item.children.length > 0"
                              :index="item.children[0].path">
                    <i :class="item.iconCls"></i>{{ item.children[0].name }}
                </el-menu-item>
            </template>
            <el-menu-item index="" @click="logout">
                <i class="fa fa-unlock"></i> Wyloguj
            </el-menu-item>
        </el-menu>
    </aside>
</template>
<script>
    import {SiteSettings} from "@/api";

    export default {
        methods: {
            getChildPath (parentPath, childPath) {
                if (parentPath === undefined) {
                    return childPath
                }
                if (parentPath.endsWith('/')) {
                    return `${parentPath}${childPath}`
                }
                return `${parentPath}/${childPath}`
            },
            handleOpen () {
            },
            handleClose () {
            },
            handleSelect: function (a, b) {
            },
            logout: function () {
                this.$confirm(this.$i18n.t('areYouSure'), this.$i18n.t('logout'), {
                    //type: 'warning'
                }).then(() => {
                    window.localStorage.removeItem('token');
                    this.$router.push('/login');
                }).catch(() => {

                });
            },
            refreshFrontend: function () {
                const msg = 'Zmiany z panelu administracyjnego zostaną wprowadzone na stronę opener.pl'
                this.$confirm(msg, 'Aktualizacja', {
                    type: 'warning'
                }).then(() => {
                    SiteSettings.refresh().then(response => {
                        this.$message({
                            message: 'Rozpoczęto aktualizację. Zmiany zostaną wprowadzone za kilka minut.',
                            type: 'success'
                        })
                    }).catch(error => {
                        const status = error.response.status
                        let msg = 'Wystąpił błąd podczas łączenia z serwerem. Spróbuj ponownie za chwilę.'

                        if (status === 400) {
                            msg = 'Proces aktualizacji jest w trakcie. Poczekaj aż się zakończy.'
                        }

                        if (status === 406) {
                            msg = 'Proces aktualizacji można przeprowadzić jedynie na środowisku produkcyjnym.'
                        }

                        this.$message({
                            message: msg,
                            type: 'error'
                        })
                    })
                })
            }
        },
        computed: {
            availableRoutes () {
                return this.$router.options.routes.filter(route => !route.hidden)
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "~@/styles/element-variables";

    .container {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;
        .main {
            display: flex;
            position: absolute;
            top: 60px;
            bottom: 0px;
            overflow: hidden;
            aside {
                flex: 0 0 220px;
                width: 220px;
                .el-menu {
                    height: 100%;
                    background: #2F4050;
                    font-size: 120px;
                }
            }
            .menu-expanded {
                flex: 0 0 220px;
                width: 220px;
            }
        }
    }

    .menu__item {
        font-size: 13px;
        font-weight: 600;
    }

    .el-submenu {
        transition: all .3s;
    }

    .el-submenu.is-opened {
        background: #293846;
        border-left: 4px solid $--color-primary;
    }

    .el-menu-item, .el-submenu .el-menu-item {
        background: #293846;
        color: #a7b1c2;
    }

    .el-menu-item.is-active {
        background: $--color-primary;
        color: #dceaff;
    }

    .refresh-frontend {
        background: #409EFF;
        color: #ffffff;
    }

    .white {
        color: #ffffff;
    }
</style>



// WEBPACK FOOTER //
// SidebarComponent.vue?1f7294cd